import { createColumn, defaultColumns, inputTextField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Description',
    field: 'description',
    /* displayValue: obj => {
      return obj.membershipType.description
    }, */
    type: 'text',
    component: inputTextField({ req: true })
  }),
  createColumn({
    label: 'Constant Contact List ID',
    field: 'ccListId',
    type: 'text',
    visible: false,
    component: null
  })
].concat(defaultColumns)
